import { api } from './client';
import type { BingDateGrain } from './bingDashboard';
import type { GoogleReportRow } from './googleDashboard';

export type TikTokReportType = 'overview' | 'target' | 'new_old' | 'detail';
export type TikTokReportRow = GoogleReportRow;

export interface TikTokReportResponse {
  list: TikTokReportRow[];
  summary: TikTokReportRow | null;
  region: string;
  site_code: string;
  start_date: string;
  end_date: string;
  date_grain: BingDateGrain;
  report: TikTokReportType;
}

export interface TikTokReportParams {
  brand_id: string;
  site_id: string;
  start_date: string;
  end_date: string;
  date_grain: BingDateGrain;
  report: TikTokReportType;
  dimensions?: string;
  target_type?: string;
  new_old_type?: string;
  ad_form_type?: string;
  bid_type?: string;
  material_type?: string;
  positioning_type?: string;
  directory_type?: string;
  customer_type?: string;
  price_type?: string;
  audience_type?: string;
  loading_page_type?: string;
  product_type?: string;
  new_customer_segment?: string;
  new_customer_segment_detail?: string;
  old_customer_segment?: string;
  old_customer_segment_detail?: string;
  account_name?: string;
  campaign_id?: string;
  campaign_name?: string;
  adset_name?: string;
  ad_name?: string;
}

type ApiEnvelope<T> = { code: number; data: T; message?: string };

export const tiktokDashboardApi = {
  getReport: (params: TikTokReportParams) =>
    api.get<ApiEnvelope<TikTokReportResponse>>('/ad-dashboard/tiktok/report', { params }),
};
